module.exports = __webpack_public_path__ + "static/media/sign-in-background3.d57cf203.jpg";